module.exports = __webpack_public_path__ + "img/ELC_ReportGroup_Icon.d5257fa2.png";